'use client';
import { Button } from '@paction-2.0/ui';

import styles from '@/features/auth/components/AuthCardShell/authCardShell.module.scss';
import { AuthFormInput } from '@/features/auth/components/AuthFormInput/AuthFormInput';
import { useAuthLoginForm } from './useAuthLoginForm';

type Props = {
  redirect?: string | null;
  showSessionTimedOut?: boolean;
  initialEmail?: string;
};

export function AuthLoginForm({
  redirect,
  showSessionTimedOut,
  initialEmail
}: Props) {
  const {
    email,
    password,
    submitting,
    error,
    canSubmit,
    emailError,
    emailErrorText,
    handleEmailChange,
    handlePasswordChange,
    handleSubmit
  } = useAuthLoginForm({ redirect, initialEmail });

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.formField}>
        <AuthFormInput
          type="email"
          autoComplete="email"
          name="email"
          placeholder="Email"
          value={email}
          onChange={(event) => handleEmailChange(event.target.value)}
          error={emailError}
          errorText={emailErrorText ?? undefined}
        />
      </div>
      <div className={styles.formField}>
        <AuthFormInput
          type="password"
          autoComplete="current-password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={(event) => handlePasswordChange(event.target.value)}
        />
      </div>

      <div className={styles.rightLinkRow}>
        <a href="/forgot" className={styles.link}>
          Forgot password?
        </a>
      </div>

      <div className={styles.formActions}>
        {showSessionTimedOut ? (
          <p className={styles.subtitle}>Session timed out</p>
        ) : null}

        {error ? (
          <p className={`${styles.message} ${styles.messageError}`}>{error}</p>
        ) : null}

        <Button
          type="submit"
          disabled={!canSubmit || submitting}
          className={styles.fullWidthButton}
        >
          {submitting ? 'Logging in…' : 'Login'}
        </Button>
      </div>
    </form>
  );
}
